import Table from "./table";
import { useMemo, useState} from "react";
import { usePurchaseLinksState } from "../../context/PurchaseLinksContext";
import moment from "moment/moment";
import MangeLinksDropdownMenu from "./dashboard/manage-links-drodown-menu";
import NewReleaseModal from "../modals/new-release";

const Updates = () => {
  const { links, currentPage } = usePurchaseLinksState();
  const [currentTab, setCurrentTab] = useState("");
  const [releaseModalOpen, setReleaseModalOpen] = useState(false);

  const handleModalOpen = () => {
    console.log(!releaseModalOpen);
    setReleaseModalOpen(!releaseModalOpen);
  }

  const columns = useMemo(() => [
    { header: "Description", accessor: "description" },
    { header: "Limit", id: "purchase_limit", accessor: (row) => { return row.purchase_limit === 0 ? "Unlimited" : row.purchase_limit } },
    { header: "Start Date", id: "start_at", accessor: (row) => { return moment(row.start_at).format("DD/MM/yyy HH:mm:ss") } },
    { header: "Expiry", id: "expire_at", accessor: (row) => { return moment(row.expire_at).format("DD/MM/yyy HH:mm:ss") } },
    { header: "Enabled", id:"enabled", accessor: (row) => { return row.enabled ? "True" : "False" } },
    {
      header: "Manage",
      id: "manage_link",
      Cell: ({cell}) => (
        <MangeLinksDropdownMenu cell={cell}/>
      )
    }
  ]);

  const handleTabClick = async(tab) => {

  }

  return (
    <>
      <NewReleaseModal open={releaseModalOpen} setOpen={handleModalOpen}/>


      <div id="dropdownDotsHorizontal" className="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600">
        <ul className="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownMenuIconHorizontalButton">
          <li>
            <a href="#" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Dashboard</a>
          </li>
          <li>
            <a href="#" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Settings</a>
          </li>
          <li>
            <a href="#" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Earnings</a>
          </li>
        </ul>
        <div className="py-2">
          <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white">Separated link</a>
        </div>
      </div>

      {/* Header Title */}
      <div className="px-5 md:px-10 py-7">
        <h1 className="text-black dark:text-white text-3xl font-semibold">
          Updates
        </h1>
      </div>

      {/* Inner Navigation */}
      <nav className="px-5 md:px-10 border-b max-w-full overflow-auto flex space-x-5">
        <a
          onClick={() => handleTabClick('active')}
          className={
            currentTab === "" ?
              "pb-1.5 text-sm whitespace-nowrap transition duration-100 cursor-pointer text-black dark:text-white border-b-2 border-black dark:border-white"
              :
              "pb-1.5 text-sm whitespace-nowrap transition duration-100 cursor-pointer text-black dark:text-white !text-opacity-50 hover:!text-opacity-100"
          }>
          Active
        </a>
      </nav>

      {/* Page */}
      <div className="px-5 md:px-10 pt-5 pb-10">
        {/* Search Bar */}

        {/* Grid */}
        <div className="w-full">
          <div className="flex items-center justify-between text-sm mt-4 pb-3">
            <div className="flex-1 relative group max-w-4xl ">
              <input
                placeholder="Search by description"
                className="pl-9 relative transition focus:!ring focus-within:z-20 bg-white bg-[#18181B] placeholder-gray-300 dark:placeholder-gray-500 text-gray-800 dark:text-white py-0 px-3 w-full disabled:cursor-not-allowed h-8 text-sm rounded-md input-group:rounded-none input-group:first:rounded-l-md input-group:last:rounded-r-md input-group:-ml-px input-group:first:!ml-0 !border-gray-200 dark:!border-gray-700 focus:!border-blue-300 dark:focus:!border-blue-400 !ring-blue-400 !ring-opacity-40">
              </input>
            </div>

            <div className="flex justify-end space-x-2 mr-4">
              <div className="ml-3"><a
                className="px-3 h-8 text-sm rounded-md text-white dark:text-black bg-gray-800 dark:bg-gray-100 hover:bg-gray-700 dark:hover:bg-white border border-transparent after:via-gray-600 dark:after:via-white focus:outline-none shadow-sm hover:shadow focus:shadow active:shadow-none box-border relative after:absolute inline-flex items-center align-middle min-w-min select-none outline-none justify-center text-center whitespace-nowrap transition appearance-none focus:outline-none font-medium"
                type="button" target="_self" href="#" onClick={handleModalOpen}>
                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="plus"
                     className="svg-inline--fa fa-plus mr-2" role="img"
                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path fill="currentColor"
                        d="M432 256C432 269.3 421.3 280 408 280h-160v160c0 13.25-10.75 24.01-24 24.01S200 453.3 200 440v-160h-160c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h160v-160c0-13.25 10.75-23.99 24-23.99S248 58.75 248 72v160h160C421.3 232 432 242.8 432 256z"></path>
                </svg>
                New Release<kbd
                className="font-sans hidden sm:inline-block rounded px-1 text-xs bg-gray-400 bg-opacity-40 ml-2">N</kbd></a>
              </div>

              <div>
                <button
                  disabled={links.page === 0}
                  className="dark:disabled:bg-red-500 disabled:cursor-not-allowed cursor-pointer px-3 h-8 text-sm rounded-md text-gray-800 dark:text-white bg-white dark:bg-gray-700 hover:bg-white dark:hover:bg-gray-600 border border-gray-300 dark:border-gray-600 after:via-gray-100 dark:after:via-gray-500 focus:outline-none shadow-sm hover:shadow focus:shadow active:shadow-none box-border relative after:absolute inline-flex items-center align-middle min-w-min select-none outline-none justify-center text-center whitespace-nowrap transition appearance-none focus:outline-none font-medium">
                  Previous
                </button>
              </div>
              <div>
                <button
                  disabled={!links.hasMore}
                  className="dark:disabled:bg-red-500 disabled:cursor-not-allowed cursor-pointer px-3 h-8 text-sm rounded-md text-gray-800 dark:text-white bg-white dark:bg-gray-700 hover:bg-white dark:hover:bg-gray-600 border border-gray-300 dark:border-gray-600 after:via-gray-100 dark:after:via-gray-500 focus:outline-none shadow-sm hover:shadow focus:shadow active:shadow-none box-border relative after:absolute inline-flex items-center align-middle min-w-min select-none outline-none justify-center text-center whitespace-nowrap transition appearance-none focus:outline-none font-medium">
                  Next
                </button>
              </div>
            </div>
          </div>


        </div>
      </div>
    </>
  )
}


export default Updates;